import React from "react";
import { IconType } from "react-icons";
import { LuIndianRupee } from "react-icons/lu";

import { sanitizeRate } from "../../static/processRate";
import Input from "./Input";
import cx from "./cx";
import { fieldInputClass, formFieldIconClass } from "./styles";

type Props = Omit<
  React.InputHTMLAttributes<HTMLInputElement>,
  "value" | "onChange"
> & {
  value: string;
  onChange: (value: string) => void;
  hasError?: boolean;
  // The box's icon (₹ by default) and its classes, for a form that shows rates its own way; the forms' usual icon
  // place by default.
  icon?: IconType;
  iconClassName?: string;
};

// A rate box. The rate stays as typed text, kept to digits with up to 2 decimals; use it through a Controller.
const RateInput = React.forwardRef<HTMLInputElement, Props>(
  (
    {
      value,
      onChange,
      hasError,
      icon: Icon = LuIndianRupee,
      iconClassName = formFieldIconClass,
      className,
      ...props
    },
    ref
  ) => (
    <div className="relative">
      <Icon className={iconClassName} />
      <Input
        ref={ref}
        type="text"
        inputMode="decimal"
        autoComplete="off"
        maxLength={11}
        value={value ?? ""}
        className={cx(fieldInputClass(hasError), "bg-white", className)}
        onChange={(e) => onChange(sanitizeRate(e.target.value))}
        {...props}
      />
    </div>
  )
);

RateInput.displayName = "RateInput";

export default RateInput;
